<template>
  <ValidationObserver ref="observer"
        tag="form"
        class="mx-2">
        <div>
            <div class="row d-flex align-items-center mt-5">
                <div class="col-sm-6">
                    <h4>Lietotāju saraksts atbilstoši periodiskumam</h4>
                </div>
                <div class="col-sm-6 d-flex justify-content-around">
                    <UserOvpJobConditionsGenerate/>
                </div>
            </div>
            <UserOvpJobConditionList :hasSearch="true"/>
        </div>
    </ValidationObserver>
</template>
<script>
    import {ValidationObserver} from 'vee-validate';
    import UserOvpJobConditionsGenerate from './UserOvpJobConditionsGenerate';
    import UserOvpJobConditionList from './UserOvpJobConditionList';   

    export default {
        name: 'users-ovp-job-conditions',
        components: {UserOvpJobConditionList, UserOvpJobConditionsGenerate, ValidationObserver},
        data: () => ({}),
    }
</script>